<template>
  <div>

    <div class="header-seach-box">
      <el-button type="success" class="toTransLfet" @click="addCategoryBtn()">添加类型</el-button>
    </div>  
    <el-card>
      <el-table :data="categoryList">
        <el-table-column label="id" prop="id"></el-table-column>
        <el-table-column label="类型中文名称" prop="zhName"></el-table-column>
        <el-table-column label="类型英文名称" prop="enName"></el-table-column>
        <el-table-column label="类型韩文名称" prop="krName"></el-table-column>
        <el-table-column label="类型越南文名称" prop="viName" ></el-table-column>
        <el-table-column label="优先级" prop="sort"></el-table-column>
        <el-table-column label="显示隐藏">
            <template slot-scope="scope">
                <el-switch
                    active-color="#13ce66"
                    @change="handleShowedChange(scope.row.id, $event)"
                    :value="scope.row.showed"
                ></el-switch>
            </template>
        </el-table-column>
        <el-table-column label="操作">
            <template slot-scope="scope">
                <el-button type="primary" @click="handleEdit(scope.row)">修改</el-button>
                <el-button type="danger" icon="el-icon-delete" circle size="small" @click="handleRemove(scope.row.id)"/>
            </template>
        </el-table-column>
      </el-table>
      <div class="pager-wrap">
        <pagination
          :size="pager.size"
          :page="pager.page"
          :total="categoryTotal"
          @pageChanged="handlPageChanged"
        >
        </pagination>
      </div>
    </el-card>

    <el-dialog title="添加修改类型" class="bk-ui5-dialog" :visible.sync="editDialog">
      <el-form ref="form" label-width="150px">
        <el-form-item label-width="180px" label="类型中文名称">
            <el-input v-model="addCategory.zhName" ></el-input>
       </el-form-item>
        <el-form-item label-width="180px" label="类型英文名称">
          <el-input v-model="addCategory.enName" ></el-input>
        </el-form-item>
        <el-form-item label-width="180px" label="类型韩文名称">
          <el-input v-model="addCategory.krName" ></el-input>
        </el-form-item>
        <el-form-item label-width="180px" label="类型越南语名称">
          <el-input v-model="addCategory.viName" ></el-input>
        </el-form-item>
        <el-form-item label-width="180px" label="优先级">
          <el-input v-model="addCategory.sort" ></el-input>
        </el-form-item>
        <el-form-item label="显示/隐藏">
            <el-switch v-model="addCategory.showed" active-color="#13ce66"/>
        </el-form-item>
      </el-form>  
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" @click="editCommitBtn()">提 交</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
    import api from '../api';
    import "../store";
    import Pagination from "components/pagination";
    import { mapActions, mapGetters, mapState } from "vuex";
    import { formatTable } from "../../../common/tools.js";

    export default {
        name: "category",
        data() {
            return {
                categoryType: 1,
                pager: {
                    page: 1,
                    size: 10,
                },
                editDialog: false,
                addCategory: {},
            };
        },    
        computed: {
            ...mapState("ProductManage", [
                "categoryList",
                "categoryTotal",
            ]),
        },
        methods:{
            ...mapActions("ProductManage", ["getCategoryList","updateShowedStatus","createOrUpdateProductCategory","deleteCategory"]),
            queryTotalData(clr) {
                if (clr) this.pager.page = 1;
                let q = {
                page: this.pager.page,
                size: this.pager.size,
                };
                this.getCategoryList(q);
            },

            handlPageChanged(pagination) {
                this.pager.page = pagination.page;
                this.pager.size = pagination.size;
                this.queryTotalData();
            },

            handleShowedChange(categoryId, showed) {
                this.$confirm("确认要进行此操作吗？", "提示", { type: "warning" })
                .then(() => {
                        this.updateShowedStatus({ categoryId, showed }).then(() => {
                        this.$message.success("操作成功！");
                        this.queryTotalData();
                    });
                });
            },

            addCategoryBtn(){
                this.addCategory = {};
                this.editDialog = true;
            },

            handleEdit(category) {
                this.editDialog = true;
                this.addCategory = category;
                this.addCategory.categoryId = category.id;
            },

            editCommitBtn() {
                this.createOrUpdateProductCategory(this.addCategory).then(() =>{
                    this.$message.success("操作成功！");
                    this.addCategory = {};
                    this.editDialog = false;
                    this.queryTotalData();
                })

            },

            handleRemove(categoryId) {
                this.$confirm("确认要删除吗？", "提示", { type: "warning" })
                .then(() => {
                        this.deleteCategory({categoryId}).then(() => {
                        this.$message.success("操作成功！");
                        this.queryTotalData();
                        });
                });
            }

        },

        mounted() {
            this.queryTotalData();
        },
        
        components: {
            Pagination,
        },
    }
</script>

<style scoped>

</style>
